import PropTypes, { string } from 'prop-types';

import { Legend as PlasticLegend } from '@cof/plastic-components';

const Legend = ({ variant, color, id, 'data-qa-id': dataQaId, paddingBottom, paddingTop, ...props }: any) => {
    return (
        <PlasticLegend
            p="0"
            mt="xs"
            pb={paddingBottom}
            pt={paddingTop}
            style={{ color }}
            variant={variant}
            {...props}
            data-qa-id={dataQaId || `${id}-label`}
        />
    );
};

Legend.propTypes = {
    'variant': PropTypes.oneOf(['dark', 'light']),
    'color': string,
    'id': string,
    'data-qa-id': string,
    'paddingBottom': string,
    'paddingTop': string
};

Legend.displayName = 'Legend';
export default Legend;
